export enum TypSubjektu {
	PRAVNICKA_OSOBA = 'PRAVNICKA_OSOBA',
	FYZICKA_OSOBA = 'FYZICKA_OSOBA',
	FYZICKA_OSOBA_PODNIKAJICI = 'FYZICKA_OSOBA_PODNIKAJICI'
}
